var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitTickerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.34378C14.1678 9.15344 14.0091 9.95537 13.6997 10.7036C13.3902 11.4518 12.9361 12.1315 12.3633 12.7038C11.7904 13.2768 11.1101 13.7313 10.3614 14.0413C9.61274 14.3513 8.81031 14.5107 7.99998 14.5104C7.12783 14.5126 6.26526 14.3285 5.46998 13.9704L2.89198 14.3518C2.76398 14.3727 2.63282 14.362 2.50988 14.3207C2.38693 14.2794 2.27594 14.2087 2.18652 14.1148C2.09711 14.0208 2.03198 13.9065 1.9968 13.7816C1.96162 13.6568 1.95745 13.5253 1.98465 13.3984L2.34265 10.7831C2.00294 10.015 1.82937 9.18369 1.83332 8.34378C1.83221 7.53412 1.99093 6.73221 2.30039 5.98402C2.60985 5.23584 3.06395 4.5561 3.63665 3.98378C4.20958 3.41072 4.88983 2.9562 5.63852 2.6462C6.38721 2.3362 7.18965 2.1768 7.99998 2.17711C9.63639 2.17722 11.2058 2.82705 12.3633 3.98378C12.9358 4.55627 13.3897 5.23605 13.6992 5.98419C14.0086 6.73234 14.1675 7.53416 14.1667 8.34378Z",
    stroke: "#1F44DD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79528 5.55444V10.7511M5.19995 8.15844H10.4026",
    stroke: "#1F44DD",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitTickerBlue);
export default __webpack_public_path__ + "static/media/submit-ticker-blue.a105a2870df9a182dab2d1e393b64272.svg";
export { ForwardRef as ReactComponent };